/**
 * MON-4 decision D (EP-149). The customer invoice badge must not read
 * tc('status.' + invoice.status) from the COMMON namespace: status.pending
 * there is a generic string shared with parcels ("awaiting pickup"), so an
 * open invoice read the wrong copy in both liff/src/pages/InvoicesPage.tsx
 * and liff/src/pages/InvoiceDetailPage.tsx.
 *
 * The customer_app API already resolves paid/unpaid/overdue by comparing
 * due_at against the server clock (api/app/controllers/api/customer_app/
 * invoices_controller.rb#invoice_status). The client only maps that
 * resolved status onto invoice-specific copy; it never recomputes the
 * due-date comparison itself. An invoice not yet paid reads รอชำระ before
 * its due date and ค้างชำระ only after it; paid is unaffected.
 *
 * partially_paid (MON-11) is sent for an invoice with a payment against it
 * and a balance left, before its due date; after the due date it is overdue.
 *
 * Both pages import this one mapping so they cannot drift from each other.
 */
export function invoiceStatusI18nKey(status: string): string {
  switch (status) {
    case 'paid':
      return 'status.paid'
    case 'overdue':
      return 'status.overdue'
    case 'partially_paid':
      return 'status.partially_paid'
    default:
      return 'status.pending_payment'
  }
}

export function invoiceStatusBadgeClass(status: string): string {
  switch (status) {
    case 'paid':
      return 'status-badge-success'
    case 'overdue':
      return 'status-badge-error'
    case 'partially_paid':
      return 'status-badge-info'
    default:
      return 'status-badge-warning'
  }
}
